<template>
	<AppLayout :title="trans('rotations.periods.title')">
		<Modal id="create-rotation-period-modal">
			<template #title>{{ trans('rotations.periods.create.title') }}</template>
			<div class="grid grid-cols-1 md:grid-cols-2 gap-3">
				<LabeledObject required full>
					<template #label>{{ trans('rotations.periods.begins_on') }}</template>
					<IconDateInput v-model="newPeriod.begins_on" :min="min" icon-class="fa-solid fa-hourglass-start" full/>
				</LabeledObject>
				<LabeledObject required full>
					<template #label>{{ trans('rotations.periods.ends_on') }}</template>
					<IconDateInput v-model="newPeriod.ends_on" :min="newPeriod.begins_on" icon-class="fa-solid fa-hourglass-end" full/>
				</LabeledObject>
			</div>
			<template #footer>
				<PrimaryButton :color="Color.Green" @click.stop="create">
					<i class="fa-solid fa-check mr-2"/>
					{{ trans('general.confirm') }}
				</PrimaryButton>
			</template>
		</Modal>
		<template #actions>
			<PrimaryButton :color="Color.Green" @click.stop="showModal('create-rotation-period-modal')">
				<i class="fa-solid fa-plus mr-2"/>
				{{ trans('general.create') }}
			</PrimaryButton>
		</template>
		<Empty v-if="periods.length === 0"/>
		<CardGrid v-else>
			<Card v-for="period in periods" :key="`period-${period.id}`" :title="period.title">
				<template #footer>
					<Link :as="SecondaryButton" :color="Color.Blue" :href="route('association.representatives.periods.edit', period.id)">
						<i class="fa-solid fa-edit mr-2"/>
						{{ trans('general.edit') }}
					</Link>
					<Link :as="SoftButton" :color="Color.Violet" :href="route('association.representatives.periods.slots.index', period.id)">
						<i class="fa-solid fa-clock mr-2"/>
						{{ trans('rotations.periods.slots.title') }}
					</Link>
				</template>
			</Card>
		</CardGrid>
	</AppLayout>
</template>
<script setup lang="ts">
import axios from 'axios'
import dayjs from 'dayjs'
import {route} from 'ziggy-js'
import {ref, type Ref} from 'vue'
import {Link} from '@inertiajs/vue3'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import Empty from '@/Components/UI/Empty.vue'
import Card from '@/Components/UI/Cards/Card.vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import Modal from '@/Components/UI/Modals/Modal.vue'
import CardGrid from '@/Components/UI/Cards/CardGrid.vue'
import LabeledObject from '@/Components/UI/LabeledObject.vue'
import SoftButton from '@/Components/UI/Buttons/SoftButton.vue'
import IconDateInput from '@/Components/UI/Inputs/IconDateInput.vue'
import PrimaryButton from '@/Components/UI/Buttons/PrimaryButton.vue'
import SecondaryButton from '@/Components/UI/Buttons/SecondaryButton.vue'
import {type RotationPeriod} from '@/Types/Periods/Rotations/RotationPeriod'
import {showInfo, showModal, showSuccess, showValidationErrors} from '@/Helpers/general'

const props = defineProps<{
	periods:Array<RotationPeriod>,
}>()

const newPeriod:Ref<RotationPeriod> = ref({
	begins_on: '',
	ends_on: '',
} as RotationPeriod)
const periods:Ref<Array<RotationPeriod>> = ref(props.periods)
const working:Ref<boolean> = ref(false)
const min = dayjs().format('YYYY-MM-DD')

function create():void{
	if(!working.value){
		working.value = true
		showInfo(trans('general.inserting'))
		axios.post(route('association.representatives.periods.store'), newPeriod.value).then(({data}) => {
			showSuccess(trans('general.inserted'))
			periods.value.unshift(data)
		}).catch(showValidationErrors).finally(() => {
			working.value = false
		})
	}
}
</script>